export default "__VITE_ASSET__CpqkujsX__"